import { Button } from '@/components/ui/button'
import { useGuild } from 'app/frontend/base/config/context/guild'
import { useTranslation } from 'react-i18next'
import NewTeamModal from '../../../TeamDashboard/components/NewTeamModal'
import { useState } from 'react'
import ProtectedContent from 'app/frontend/base/components/ProtectedContent'

import Section from 'app/frontend/base/components/Section'
import GuildTeamCard from './components/GuildTeamCard'
import GuildOnboardingCta from '../../components/GuildOnboardingCta'
import { useGuildTeamData } from 'app/frontend/base/config/queries'
import { compareTeamsByDefaultAndName } from 'app/frontend/base/helpers/teamOrdering'

const GuildTeams = () => {
  const { guild } = useGuild()
  const { t } = useTranslation()
  const [creatingTeam, setCreatingTeam] = useState(false)
  const { data: teamData } = useGuildTeamData(guild?.id)

  const sortedTeams = [...(guild?.teamReferences || [])]
    .filter((team) => team.visibleInGuild)
    .sort(compareTeamsByDefaultAndName)

  return (
    <Section title={`Teams | ${guild?.name}`}>
      <h2 className='flex justify-between items-center'>
        <span>{t('shared.teams')}</span>
        <ProtectedContent
          section='base'
          requirement='admin'
          renderUnauthorized={false}
          requireAllTeams={true}
        >
          <Button size='sm' onClick={() => setCreatingTeam(true)}>
            {t('shared.create-new')}
          </Button>
        </ProtectedContent>
      </h2>

      {guild ? (
        <NewTeamModal setOpen={setCreatingTeam} open={creatingTeam} />
      ) : null}

      {guild && guild.teamReferences.length === 0 ? (
        <GuildOnboardingCta guild={guild} />
      ) : (
        <div className='flex flex-col gap-6 text-sm'>
          {sortedTeams.map((team) => (
            <ProtectedContent
              key={team.id}
              section='base'
              requirement='member'
              teamReference={team}
              alwaysRenderContent={true}
            >
              <GuildTeamCard
                team={team}
                roster={teamData?.[team.id]?.roster}
                eventDays={teamData?.[team.id]?.eventDays}
                medianItemLevel={teamData?.[team.id]?.medianItemLevel}
                raidProgress={teamData?.[team.id]?.raidProgress}
              />
            </ProtectedContent>
          ))}
        </div>
      )}
    </Section>
  )
}

export default GuildTeams
